import { connect } from 'react-redux'
import ArchivedFilesTable from './archived-files-table'
import { getArchivedFilesList } from '../../../../../stores/archived-files/archived-files.selectors'

const mapStateToProps = state => ({
  archivedFiles: getArchivedFilesList(state)
})

export default connect(
  mapStateToProps,
  null
)(ArchivedFilesTable)
